var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg231Dn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 53,
    viewBox: "0 0 55 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009EFF",
    d: "M18.426,45.229 C17.103,47.783 14.084,46.112 15.354,43.647 C16.432,41.552 19.022,40.285 19.022,40.285 C19.022,40.285 19.472,43.201 18.426,45.229 Z M19.728,52.838 C18.405,55.392 15.386,53.721 16.656,51.256 C17.734,49.161 20.324,47.894 20.324,47.894 C20.324,47.894 20.774,50.809 19.728,52.838 Z M34.638,52.838 C33.315,55.392 30.296,53.721 31.566,51.256 C32.644,49.161 35.234,47.894 35.234,47.894 C35.234,47.894 35.685,50.809 34.638,52.838 Z M40.805,45.229 C39.482,47.783 36.463,46.112 37.733,43.647 C38.811,41.552 41.401,40.285 41.401,40.285 C41.401,40.285 41.851,43.201 40.805,45.229 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF7800",
    points: "32.037 43.465 29.222 43.422 31.53 39.385 27.967 39.415 24.944 45.438 27.576 45.438 23.88 54.567"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    opacity: 0.4,
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C9C9C9",
    strokeWidth: 1.4,
    d: "M6.06 29.503L45.192 29.503M11.689 39.708L50.821 39.708M4.561 24.401L43.519 24.401M9.762 34.606L48.72 34.606M6.06 9.093L45.192 9.093M11.689 19.298L50.821 19.298M4.561 3.99L43.519 3.99M10.29 14.16L49.248 14.16M4.561 45.097L43.519 45.097"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg231Dn);
export default __webpack_public_path__ + "static/media/231dn.cc2796d956de23982d319dcb13aafc9a.svg";
export { ForwardRef as ReactComponent };